import {
    ACTION_GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS,
    ACTION_GET_CATEGORIES_MARKETPLACE_PRODUCTS,
    ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT,
    ACTION_POST_CREATE_MARKETPLACE_PRODUCTS,
    ACTION_GET_ALL_MONETIZATION_TYPES,
    ACTION_POST_CREATE_COMPANIES,
    ACTION_PUT_UPDATE_COMPANIES,
    ACTION_GET_FUNCTIONALITIES,
    ACTION_GET_COMPANY_BY_ID,
    ACTION_DELETE_COMPANIES,
    ACTION_GET_COMPANIES,
    ACTION_GET_COMPANY_DEMO_TYPES,
    SET_SUBCATEGORIES_MARKETPLACE_PRODUCTS,
    SET_CATEGORIES_MARKETPLACE_PRODUCTS,
    SET_COMPANIES_LIST_TYPE_DOCUMENT,
    SET_ALL_MONETIZATION_TYPES,
    SET_FUNCTIONALITIES,
    SET_COMPANIES_BY_ID,
    SET_COMPANIES,
    SET_COMPANY_DEMO_TYPES,
} from "@/views/companies/store/types/types.js"

import config from "@/views/companies/config/company_api.js";
import configP from  "@/views/products/config/product_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';
import i18n from '@/plugins/i18n';
import { CompaniesService } from "../../../services";

const _pathUri = new PathUri(config.port, config.context);
const _pathUriP = new PathUri(configP.port, configP.context);

const actions = {

    [ACTION_GET_COMPANIES]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CompaniesService.getCompanies(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const companies = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i,
                                afiliateFee: e.afiliateFee != null ? formatNumber(e.afiliateFee) : e.afiliateFee 
                            }));
                            commit(SET_COMPANIES, companies);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/allidentificationtype`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeCompany = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_COMPANIES_LIST_TYPE_DOCUMENT, typeCompany);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_COMPANY_BY_ID]: async ({ state, commit }, idCompany) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/companybyid/${idCompany}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                    .then(resp => {
                        if (resp.data.payload) {
                            const company = {
                                ...resp.data.payload,
                                afiliateFee: resp.data.payload.afiliateFee != null ? formatNumber(resp.data.payload.afiliateFee) : resp.data.payload.afiliateFee
                            }
                            commit(SET_COMPANIES_BY_ID, company);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_COMPANIES]: ({ state }, company) => {

        const formdata = new FormData();
        formdata.append("companyName", company.companyName);
        formdata.append("identificationId", company.identificationId);
        formdata.append("identificationNumber", company.identificationNumber);
        formdata.append("contactName", company.contactName);
        formdata.append("contactNumber", company.contactNumber);
        formdata.append("email", company.email);
        formdata.append("monetizationIds", company.monetizationTypes);
        formdata.append("imageFile", company.imageFile);
        formdata.append("afiliateFee", parseFloat(company.afiliateFee.replace(/[$,]/g, '')).toFixed(2));
        if (company.monthlyCutoffDay !== null && company.monthlyCutoffDay !== undefined) {
            formdata.append("monthlyCutoffDay", company.monthlyCutoffDay);
        }
        if (company.idTipoEmpresaDemo !== null && company.idTipoEmpresaDemo !== undefined) {
            formdata.append("idTipoEmpresaDemo", company.idTipoEmpresaDemo);
        }
        return new Promise((resolve, reject) => {

            try {
                state.loading = true;
                axios({
                    method: 'post',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/create/company`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    },
                    data: formdata,
                    redirect: 'follow'
                })
                    .then(async (resp) => {
                        // Agrega una condición para verificar si la respuesta fue exitosa

                        if (resp && resp.status === 200) {
                            await Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: i18n.t('companies.actionPostCreateCompanies.success'),
                                showConfirmButton: false,
                                timer: 2500
                            });
                            resolve(resp);
                        } else {
                            // Si la respuesta no es exitosa, puedes manejarlo aquí
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_COMPANIES]: async ({ state }, company) => {

        const formdata = new FormData();

        return await new Promise((resolve, reject) => {
            formdata.append("companyName", company.companyName);
            formdata.append("identificationId", company.identificationId);
            formdata.append("identificationNumber", company.identificationNumber);
            formdata.append("contactName", company.contactName);
            formdata.append("contactNumber", company.contactNumber);
            formdata.append("email", company.email);
            formdata.append("monetizationIds", company.monetizationTypes);
            formdata.append("imageFile", company.imageFile);
            formdata.append("afiliateFee", parseFloat(company.afiliateFee).toFixed(2));
            if (company.monthlyCutoffDay !== null && company.monthlyCutoffDay !== undefined) {
                formdata.append("monthlyCutoffDay", company.monthlyCutoffDay);
            }
            if (company.idTipoEmpresaDemo !== null && company.idTipoEmpresaDemo !== undefined) {
                formdata.append("idTipoEmpresaDemo", company.idTipoEmpresaDemo);
            }


            state.loading = true;
            axios({
                method: 'post',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/update/company/${company.companyId}`,
                headers: {
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },
                data: formdata,
                redirect: 'follow'
            })
                .then(async (resp) => {
                    if (resp && resp.status === 200) {

                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('companies.actionPutUpdateCompanies.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });

                        resolve(resp);

                    } else {
                        // Si la respuesta no es exitosa, puedes manejarlo aquí
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },

    [ACTION_DELETE_COMPANIES]: async ({ state }, companyId) => {
        state.loading = true;
        return await new Promise((resolve, reject) => {
            state.loading = true;
            axios({
                method: 'delete',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/deletecompanybyid/${companyId}`,
                headers: {
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                },

                redirect: 'follow'
            })
                .then(async (resp) => {

                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('companies.actionDeleteCompanies.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);

                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
        });
    },
   
    [ACTION_GET_CATEGORIES_MARKETPLACE_PRODUCTS]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CompaniesService.getCategoriesMarketplaceProducts(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const categoriesProducts = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_CATEGORIES_MARKETPLACE_PRODUCTS, categoriesProducts);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS]: async ({ state, commit }, data) => {
        let sub = data.categoryId
        let empre= data.companyId
           return new Promise((resolve, reject) => {
               try {
                   state.loading = true;
   
                   axios({
                       method: 'get',
                       url: `${configP.baseUrl + _pathUriP.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/assignment/category/${sub}/company/${empre}`,
                       headers: {
                           'idEmpresa': sessionStorage.getItem("idEmpresa"),
                           'idUsuario': sessionStorage.getItem("idUsuario")
                       }
                   })
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const subCategoriesProducts = resp.data.payload.map((subCategory, i) => ({
                                ...subCategory,
                                activeDialogClient: false,
                                index: i,
                                product: subCategory.product.map(product => ({
                                    ...product,
                                    price: product.price != null ? formatNumber(product.price) : product.price
                                }))
                            }));
                            commit(SET_SUBCATEGORIES_MARKETPLACE_PRODUCTS, subCategoriesProducts);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_MARKETPLACE_PRODUCTS]: ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CompaniesService.postCreateProducts({ idGroup, idEmpresa, idUsuario, data })
                    .then(async response => {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: response.data.payload.message,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        EventBus.$emit('reload-update-affiliatedUser');
                        resolve(response.data);
                        window.location.reload();

                    })
                    .catch(error => {
                        console.error(i18n.t('label.actionErrorRequest'), error);
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_ALL_MONETIZATION_TYPES]: async ({ state, commit }, companyId) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/empresas/allmonetizationtype/${companyId}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const monetizationTypes = resp.data.payload;
                            
                            commit(SET_ALL_MONETIZATION_TYPES, monetizationTypes);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_COMPANY_DEMO_TYPES]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CompaniesService.getCompanyDemoTypes(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            commit(SET_COMPANY_DEMO_TYPES, resp.data.payload);
                            resolve(resp.data.payload);
                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_FUNCTIONALITIES]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                CompaniesService.getFunctionalities(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const companies = resp.data.payload;
                            commit(SET_FUNCTIONALITIES, companies);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loading = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
}
function formatNumber(value) {
    return '$' + parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default actions;